var _style, _rect, _path, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1156 650",
    style: {
      enableBackground: "new 0 0 1156 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B22234;}\n\t.st1{stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n\t.st2{fill:#3C3B6E;}\n\t.st3{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1235,
    height: 650
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,75h1235 M1235,175H0 M0,275h1235 M1235,375H0 M0,475h1235 M1235,575H0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 494,
    height: 350
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "st3",
    d: "M41.2,15l11.8,36.2L22.1,28.8h38L29.4,51.2L41.2,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_1_",
    className: "st3",
    d: "M41.2,85l11.8,36.2L22.1,98.8h38l-30.8,22.4L41.2,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_2_",
    className: "st3",
    d: "M41.2,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L41.2,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_3_",
    className: "st3",
    d: "M41.2,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L41.2,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_4_",
    className: "st3",
    d: "M41.2,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L41.2,295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_5_",
    className: "st3",
    d: "M82.3,50l11.8,36.2L63.3,63.8h38L70.6,86.2L82.3,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_6_",
    className: "st3",
    d: "M82.3,120l11.8,36.2l-30.8-22.4h38l-30.8,22.4L82.3,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_7_",
    className: "st3",
    d: "M82.3,190l11.8,36.2l-30.8-22.4h38l-30.8,22.4L82.3,190z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_8_",
    className: "st3",
    d: "M82.3,260l11.8,36.2l-30.8-22.4h38l-30.8,22.4L82.3,260z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_9_",
    className: "st3",
    d: "M123.5,15l11.8,36.2l-30.8-22.4h38l-30.8,22.4L123.5,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_10_",
    className: "st3",
    d: "M123.5,85l11.8,36.2l-30.8-22.4h38l-30.8,22.4L123.5,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_11_",
    className: "st3",
    d: "M123.5,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L123.5,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_12_",
    className: "st3",
    d: "M123.5,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L123.5,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_13_",
    className: "st3",
    d: "M123.5,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L123.5,295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_14_",
    className: "st3",
    d: "M164.7,50l11.8,36.2l-30.8-22.4h38l-30.8,22.4L164.7,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_15_",
    className: "st3",
    d: "M164.7,120l11.8,36.2l-30.8-22.4h38l-30.8,22.4L164.7,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_16_",
    className: "st3",
    d: "M164.7,190l11.8,36.2l-30.8-22.4h38l-30.8,22.4L164.7,190z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_17_",
    className: "st3",
    d: "M164.7,260l11.8,36.2l-30.8-22.4h38l-30.8,22.4L164.7,260z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_18_",
    className: "st3",
    d: "M205.8,15l11.8,36.2l-30.8-22.4h38l-30.8,22.4L205.8,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_19_",
    className: "st3",
    d: "M205.8,85l11.8,36.2l-30.8-22.4h38l-30.8,22.4L205.8,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_20_",
    className: "st3",
    d: "M205.8,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L205.8,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_21_",
    className: "st3",
    d: "M205.8,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L205.8,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_22_",
    className: "st3",
    d: "M205.8,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L205.8,295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_23_",
    className: "st3",
    d: "M247,50l11.8,36.2L228,63.8h38l-30.8,22.4L247,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_24_",
    className: "st3",
    d: "M247,120l11.8,36.2L228,133.8h38l-30.8,22.4L247,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_25_",
    className: "st3",
    d: "M247,190l11.8,36.2L228,203.8h38l-30.8,22.4L247,190z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_26_",
    className: "st3",
    d: "M247,260l11.8,36.2L228,273.8h38l-30.8,22.4L247,260z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_27_",
    className: "st3",
    d: "M288.2,15l11.8,36.2l-30.8-22.4h38l-30.8,22.4L288.2,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_28_",
    className: "st3",
    d: "M288.2,85l11.8,36.2l-30.8-22.4h38l-30.8,22.4L288.2,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_29_",
    className: "st3",
    d: "M288.2,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L288.2,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_30_",
    className: "st3",
    d: "M288.2,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L288.2,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_31_",
    className: "st3",
    d: "M288.2,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L288.2,295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_32_",
    className: "st3",
    d: "M329.3,50l11.8,36.2l-30.8-22.4h38l-30.8,22.4L329.3,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_33_",
    className: "st3",
    d: "M329.3,120l11.8,36.2l-30.8-22.4h38l-30.8,22.4L329.3,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_34_",
    className: "st3",
    d: "M329.3,190l11.8,36.2l-30.8-22.4h38l-30.8,22.4L329.3,190z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_35_",
    className: "st3",
    d: "M329.3,260l11.8,36.2l-30.8-22.4h38l-30.8,22.4L329.3,260z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_36_",
    className: "st3",
    d: "M370.5,15l11.8,36.2l-30.8-22.4h38l-30.8,22.4L370.5,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_37_",
    className: "st3",
    d: "M370.5,85l11.8,36.2l-30.8-22.4h38l-30.8,22.4L370.5,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_38_",
    className: "st3",
    d: "M370.5,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L370.5,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_39_",
    className: "st3",
    d: "M370.5,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L370.5,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_40_",
    className: "st3",
    d: "M370.5,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L370.5,295z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_41_",
    className: "st3",
    d: "M411.7,50l11.8,36.2l-30.8-22.4h38l-30.8,22.4L411.7,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_42_",
    className: "st3",
    d: "M411.7,120l11.8,36.2l-30.8-22.4h38l-30.8,22.4L411.7,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_43_",
    className: "st3",
    d: "M411.7,190l11.8,36.2l-30.8-22.4h38l-30.8,22.4L411.7,190z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_44_",
    className: "st3",
    d: "M411.7,260l11.8,36.2l-30.8-22.4h38l-30.8,22.4L411.7,260z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s5_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_45_",
    className: "st3",
    d: "M452.8,15l11.8,36.2l-30.8-22.4h38l-30.8,22.4L452.8,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_46_",
    className: "st3",
    d: "M452.8,85l11.8,36.2l-30.8-22.4h38l-30.8,22.4L452.8,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_47_",
    className: "st3",
    d: "M452.8,155l11.8,36.2l-30.8-22.4h38l-30.8,22.4L452.8,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_48_",
    className: "st3",
    d: "M452.8,225l11.8,36.2l-30.8-22.4h38l-30.8,22.4L452.8,225z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_49_",
    className: "st3",
    d: "M452.8,295l11.8,36.2l-30.8-22.4h38l-30.8,22.4L452.8,295z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.d1fdbf46.svg";
export { ForwardRef as ReactComponent };